module.exports = __webpack_public_path__ + "static/media/path06.2849f84e.png";